export const IsolvedLogoFullLight = (props: {
  classes: {
    svg: string;
  };
}) => {
  return (
    <svg
      className={props.classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1080 288"
    >
      <path
        d="M1000.84,49.41c0,69.7,0,114.53,0,184.09c0,0.87,0,2.63-2.57,2.62h-35.33c-2.55,0.01-3.36-1.1-3.41-3.46v-6.29
          c-0.31-0.32,0.54-0.31,0,0c-17.14,12.2-36.77,17.02-56.33,11.4c-28.01-8.06-44.74-27.78-51.22-55.74
          c-5.04-21.72-2.8-43.04,7.95-62.92c16.29-30.11,54.1-43.78,84.65-30.72c4.36,1.87,8.4,4.49,13.01,7c0-1.52,0-2.81,0-4.1
          c-0.06-22.39-0.04-19.43-0.25-41.83c0,0-0.31-2.5,2.01-2.5c11.78,0.12,25.68,0.07,37.46,0c0.53,0,1.07,0,1.68,0
          C1000.84,46.96,1000.84,48.6,1000.84,49.41z M958.31,159.51c0-2.76-0.59-6.53-1.63-10.62c-3.09-12.15-10.07-20.89-22.75-24.04
          c-12.48-3.1-23.12,0.15-31.55,9.86c-12.1,13.95-12.53,37.26-1.13,51.76c12.29,15.64,35.58,16.63,48.26,1.96
          C956.18,180.72,958.02,171.36,958.31,159.51z"
      />
      <path
        d="M730.61,177.91c1.78,10.29,11.75,20.05,23.73,22.88c13.01,3.07,28.81,2.59,39.78-16.47c0.16-0.27,1.39-2.06,3.54-1.26
          c11.91,3.71,23.88,7.45,36.05,11.25c2.27,0.74,1.61,2.3,1.31,3.09c-2.53,6.65-6.34,12.21-10.96,17.22
          c-18.57,20.13-41.95,27.39-68.72,25.06c-15.77-1.37-30.12-6.7-42.55-16.62c-15.85-12.65-24.9-29.23-27.53-49.22
          c-2.35-17.85-0.26-35.18,8.27-51.24c12.6-23.74,33.27-35.48,59.41-38.51c15.51-1.8,30.71-0.31,45.04,6.17
          c20.16,9.11,31.88,25.25,37.38,46.25c2.96,11.3,3.54,22.8,2.99,34.44c-0.16,3.27-0.9,4.37-4.44,4.4
          c-33.19,0.22-66.37,0.66-99.56,1.04c-0.73,0.01-1.46,0.01-2.25,0.01C731.09,176.33,730.31,176.61,730.61,177.91z M791.43,140.12
          c-1.39-10.93-15.62-20.13-30.93-20.03c-13.67,0.09-28.17,10.28-29.34,20.23c-0.04,0.35,0,1.05,0.94,1.05c19.45,0,38.9,0,58.37,0
          C791.85,141.38,791.49,140.54,791.43,140.12z"
      />
      <path
        d="M292.7,160.81c0.02-43.47,34.67-77.93,78.4-77.96c43.6-0.03,78.29,34.61,78.21,78.1c-0.08,43.94-35.3,79.68-78.36,79.51
          C327.64,240.29,292.68,204.71,292.7,160.81z M371.33,123.49c-7.55,0.02-14.32,2.36-20.3,6.93c-16.81,12.83-19.67,39.47-6.05,56.32
          c14.89,18.44,43.73,16.38,55.63-4.06c5.21-8.95,6.59-18.66,4.95-28.85C402.73,136.42,388.1,123.44,371.33,123.49z"
      />
      <path
        d="M523,86.91c7.31,0.05,33.79,0.25,45.48,0c1.97,0,2.3,2,2.3,2c9.16,24.48,27.97,74.04,32.66,86.31
          c1.2,3.06,2.04,0.96,2.4,0.16c0.18-0.41,22.26-58.64,32.82-86.47c0,0,0.58-2,2.72-1.99c11.26,0.23,35.14,0.02,43.36-0.01
          c1.77-0.01,2.64,1.29,1.81,3.27c-7.28,17.4-41.99,100.56-59.87,142.75c-0.97,2.28-2.1,3.22-4.68,3.19l-35.34-0.01
          c-2.28,0.02-3.38-0.75-4.25-2.8c-18.5-43.62-54.67-130.21-60.58-144.4C521.33,87.71,521.96,86.9,523,86.91z"
      />
      <path
        d="M467.46,46.97h39.19c3.08,0,3.57,0.65,3.57,3.61c-0.07,69.45-0.04,112.41,0.04,181.86c0,3-0.87,3.79-3.81,3.76
          c-12.79-0.15-25.58-0.12-38.38-0.02c-2.49,0.02-3.53-0.49-3.53-3.3c0.08-69.9,0.03-113.31,0.04-183.21
          C464.52,47.89,465.78,46.9,467.46,46.97z"
      />
      <path
        d="M131.29,90.81v-2.03c0-1.03-0.84-1.87-1.87-1.87H87.69c-1.03,0-1.87,0.84-1.87,1.88c0,11.63,0,23.3,0,34.43
          c0,0.79,0.5,1.48,1.25,1.75c16.11,5.93,26.86,21.62,25.67,39.69c-1.06,16.17-11.48,29.31-25.7,34.59
          c-0.74,0.27-1.24,0.96-1.24,1.75c0,10.47,0,20.19,0,30.98c0,3.92,1.92,3.92,3.78,3.92c5.26,0,38.1,0,38.1,0
          c3.12,0.04,3.65-1.11,3.65-4.04C131.24,182.57,131.29,140.11,131.29,90.81z"
      />
      <path
        d="M150.36,195.79c11.31-4.96,31.51-13.82,34.85-15.28c2.03-0.77,2.66,0.91,2.73,1.09c0.24,0.57,0.38,0.92,0.51,1.23
          c6.22,15.35,23.48,23.15,39.13,17.67c0.73-0.25,1.47-0.51,2.14-0.87c3.21-1.7,6.21-3.65,6.27-7.81c0.06-3.97-2.45-6.58-5.76-7.74
          c-6.94-2.44-14.05-4.44-21.16-6.38c-8.6-2.34-17.67-3.48-25.83-6.84c-13.04-5.37-22.83-14.76-27.07-28.67
          c-3.41-11.2-0.55-21.72,5.44-31.3c9.39-15.03,23.57-23.46,40.65-26.61c23.67-4.35,43.66,1.09,62.04,18.56
          c6.23,7.06,9.21,10.95,11.89,17.73c0.59,1.49,0.9,2.63-1.04,3.42c-11.38,4.59-22.73,9.26-34.1,13.89c-0.6,0.27-1.76,0.14-2.02-0.78
          c-5.08-11.15-14.38-15.77-26.31-15.18c-13.14,0.65-18.08,10.93-11.97,14.25c3.35,1.82,7.09,3.07,10.8,4.06
          c10.56,2.82,21.28,5.05,31.76,8.13c10.46,3.07,19.66,8.47,26.57,17.19c13.76,17.37,12.08,41.85-3.98,57.07
          c-9.87,9.36-21.88,14.44-35.14,16.55c-19.71,3.14-38.6,0.84-55.9-9.76c-12.12-7.44-20.3-17.37-25.5-31.01
          C149.31,198.26,148.43,196.63,150.36,195.79z"
      />
      <circle fill="#E50082" cx="72.27" cy="162.09" r="26.21" />
      <path
        d="M1021.67,73.3c-1.81,0-3.51-0.34-5.1-1.02c-1.59-0.68-3-1.62-4.21-2.84c-1.21-1.21-2.16-2.61-2.84-4.21
          c-0.68-1.59-1.02-3.3-1.02-5.13c0-1.81,0.34-3.51,1.02-5.09c0.68-1.58,1.62-2.98,2.84-4.18c1.21-1.2,2.62-2.15,4.21-2.84
          c1.59-0.69,3.29-1.03,5.1-1.03c1.83,0,3.53,0.34,5.12,1.03c1.58,0.69,2.98,1.63,4.19,2.84s2.16,2.6,2.84,4.18
          c0.68,1.58,1.02,3.28,1.02,5.09c0,1.83-0.34,3.54-1.02,5.13c-0.68,1.59-1.62,3-2.84,4.21c-1.21,1.21-2.61,2.16-4.19,2.84
          C1025.2,72.96,1023.49,73.3,1021.67,73.3z M1021.69,70.2c1.84,0,3.53-0.46,5.05-1.37c1.52-0.91,2.73-2.13,3.64-3.65
          c0.9-1.52,1.36-3.21,1.36-5.08c0-1.85-0.45-3.53-1.36-5.05c-0.91-1.52-2.12-2.73-3.64-3.64c-1.52-0.9-3.2-1.36-5.05-1.36
          c-1.87,0-3.56,0.45-5.08,1.36c-1.52,0.91-2.73,2.12-3.64,3.64c-0.9,1.52-1.36,3.2-1.36,5.05c0,1.86,0.45,3.56,1.36,5.08
          c0.9,1.52,2.12,2.74,3.64,3.65C1018.14,69.74,1019.83,70.2,1021.69,70.2z M1017.24,66.35V53.72h5.51c1.18,0,2.16,0.39,2.96,1.18
          c0.8,0.79,1.2,1.76,1.22,2.92c0,0.74-0.2,1.45-0.6,2.13c-0.4,0.68-0.98,1.2-1.74,1.56l2.39,4.83h-2.39l-2.17-4.42h-3.07v4.42
          H1017.24z M1019.36,59.94h3.39c0.54,0,1.01-0.2,1.41-0.61s0.6-0.91,0.6-1.51c0-0.63-0.2-1.14-0.61-1.52
          c-0.41-0.38-0.87-0.57-1.4-0.57h-3.39V59.94z"
      />
    </svg>
  );
};
